export default __webpack_public_path__ + "static/Dr(Col)KumudRai-c76bf749edeb70354ceff1177a3b7f69.png";